import {dateTime} from "services/date";
import {Organisation} from "types/Organisation";

/**
 * Transform the given organisation by deserializing object properties
 *
 * @internal
 * @param organisation
 */
export default function deserializeOrganisation(organisation: any): Organisation {
    organisation.created_at = dateTime(organisation.created_at)
    organisation.updated_at = dateTime(organisation.updated_at)

    return organisation;
}